module.exports = __webpack_public_path__ + "static/media/IMG_0556.e87fb098.JPG";